import { Component, OnInit } from '@angular/core';
import { BillingManager } from '../../../managers/billing.manager';
import { ViewStateEnum } from '../../../enums/view-state.enum';
import { OrganizationLicenseStatusEnum } from '../../../enums/organization-license-status.enum';
import { LicenseTypeEnum } from '../../../../../../../../common/src/enums/license-type.enum';
import {
  StripePaymentMethodModel,
} from '../../../../../../../../common/dist/angular/models/stripe-payment-method.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DeletePaymentMethodModalComponent,
} from '../../../components/delete-payment-method-modal/delete-payment-method-modal.component';
import {
  CreatePaymentMethodModalComponent,
} from '../../../components/create-payment-method-modal/create-payment-method-modal.component';
import { format } from 'date-fns';
import { StripeInvoiceModel } from '../../../../../../../../common/dist/angular/models/stripe-invoice.model';

@Component({
  selector: 'app-organization-billing',
  templateUrl: './organization-billing.component.html',
  styleUrls: ['./organization-billing.component.scss'],
  standalone: false,
})
export class OrganizationBillingComponent implements OnInit {

  public state: ViewStateEnum = ViewStateEnum.Loading;

  public secondColumnTitle: string = 'Chargement...';
  public secondColumnHeading: string = 'Chargement...';

  public licenseStatus: OrganizationLicenseStatusEnum;
  public licenseType: LicenseTypeEnum;

  public paymentMethods: StripePaymentMethodModel[] = [];
  public paymentMethodsState: ViewStateEnum = ViewStateEnum.Loading;

  public invoicesState: ViewStateEnum = ViewStateEnum.Loading;
  public invoices: StripeInvoiceModel[] = [];

  constructor(private readonly billingManager: BillingManager, private readonly modalService: NgbModal) {
  }

  async ngOnInit() {
    await this.refresh();
  }

  async refresh() {
    this.state = ViewStateEnum.Loading;
    this.paymentMethodsState = ViewStateEnum.Loading;

    this.billingManager.getLicense(true).then(async license => {
      this.state = ViewStateEnum.Ready;

      if (license.isFreeTrial) {
        this.secondColumnTitle = 'Essai gratuit';
        this.secondColumnHeading = await this.billingManager.getNumberOfDaysLeft(license) + ' jours restants.';
      } else {
        this.secondColumnTitle = 'Prochaine date de facturation';
        const cycleEndDate = await this.billingManager.getCycleEndDate();

        if (cycleEndDate === undefined) {
          this.secondColumnHeading = 'Non disponible';
        } else {
          this.secondColumnHeading = format(cycleEndDate, 'yyyy-MM-dd');
        }

      }

      this.licenseStatus = await this.billingManager.getLicenseStatus();
      this.licenseType = license.licenseType;
    });

    this.billingManager.getPaymentMethods().then(paymentMethods => {
      this.paymentMethods = paymentMethods;
      this.paymentMethodsState = ViewStateEnum.Ready;
    });

    await this.loadInvoices();
  }

  async loadInvoices() {
    this.invoicesState = ViewStateEnum.Loading;

    this.invoices = await this.billingManager.getInvoices();

    this.invoicesState = ViewStateEnum.Ready;
  }

  showAddPaymentMethodModal() {
    const modalRef = this.modalService.open(CreatePaymentMethodModalComponent);
    modalRef.result.then(async result => {
      this.paymentMethodsState = ViewStateEnum.Loading;
      await this.refresh();
    });
  }

  showDeletePaymentMethodModal(paymentMethod: StripePaymentMethodModel) {
    const modalRef = this.modalService.open(DeletePaymentMethodModalComponent);
    modalRef.componentInstance.paymentMethod = paymentMethod;
    modalRef.result.then(async result => {
      if (result === false) {
        return;
      }

      this.paymentMethodsState = ViewStateEnum.Loading;
      await this.billingManager.deletePaymentMethod(paymentMethod.id);
      await this.refresh();
    });
  }
}
